import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { User } from '@schemas'
import type { UserStateType } from '@redux/types'

// initial state
const initialState: UserStateType = {
	user: new User(),
	language: '',
	selfStatus: 'idle',
	selfErrorMessage: '',
	isUploadingProfileImage: false,
}

const slice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		USER: (state: UserStateType, action: PayloadAction<UserStateType['user']>) => {
			state.user = action.payload
		},

		LANGUAGE: (state: UserStateType, action: PayloadAction<string>) => {
			state.language = action.payload
		},

		// ── 관리자 My Page (본인 정보) ──────────────────────────────────────
		UPDATE_SELF_PROFILE: (
			state: UserStateType,
			action: PayloadAction<{ name: string; language: string }>,
		) => {},
		UPDATE_SELF_PASSWORD: (
			state: UserStateType,
			action: PayloadAction<{ prevPassword: string; newPassword: string }>,
		) => {},
		UPDATE_SELF_PROFILE_IMAGE: (
			state: UserStateType,
			action: PayloadAction<{ file: File }>,
		) => {},
		DELETE_SELF_PROFILE_IMAGE: (
			state: UserStateType,
			action: PayloadAction<boolean>,
		) => {},

		SELF_STATUS: (
			state: UserStateType,
			action: PayloadAction<UserStateType['selfStatus']>,
		) => {
			state.selfStatus = action.payload
		},
		SELF_ERROR_MESSAGE: (state: UserStateType, action: PayloadAction<string>) => {
			state.selfErrorMessage = action.payload
		},
		IS_UPLOADING_PROFILE_IMAGE: (
			state: UserStateType,
			action: PayloadAction<boolean>,
		) => {
			state.isUploadingProfileImage = action.payload
		},
	},
})

export const userActions = slice.actions
export default slice.reducer
